import React, {useState, useEffect} from 'react'

const AnimatedText = (props) => {
    const [seconds, setSeconds] = useState(0);
    const [effect, setEffect] = useState("in");

    const texts = props.texts;
    if (seconds > texts.length - 1) {
        setSeconds(0);
    }
    useEffect(() => {
        setTimeout(() => {
            setEffect("out");
        }, 4000);
        const interval = setInterval(() => {
            setTimeout(() => {
                setEffect("out");
            }, 4000);
            setEffect("in");
          

            setSeconds((seconds) => seconds + 1);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="animated-text">
            <h3 className={effect}>{texts[seconds]}</h3>
        </div>
    );
};
export default AnimatedText;